import "./Styles.scss"
import React, { ReactNode, useContext, useRef } from "react";
import Header from "./Header/Component";
import SideMenu from "./SideMenu/Component";
import { Container, Image } from "react-bootstrap";
import Content from "./Content/Component";
import Footer from "./Footer/Component";
import { RdContextType } from "../../@types/Rd";
import RdContext from "../../contexts/RdProvider";
import Logo from "../../assets/images/logo-edp.png";
import { useRecalculateFooter } from "../../Hooks/useWindowSize";
import Moment from "react-moment";
import { Helmet, } from "react-helmet-async";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */
const PageLayout = ({ location, children, printRef }: { location: string, children: ReactNode | JSX.Element, printRef?: React.RefObject<HTMLDivElement> }): JSX.Element => {

    const { currentCompany } = useContext(RdContext) as RdContextType,
        headerRef = useRef<HTMLElement>(null),
        pageContentRef = useRef<HTMLDivElement>(null);

    useRecalculateFooter();

    return (
        <Container ref={printRef} fluid >
            <Helmet title={`Reuniões Online - ${location}`} async />
            <Header headerRef={headerRef} />
            {
                location != null && location != "" && !location.toLocaleLowerCase().startsWith("error - ") && currentCompany?.Name != null && currentCompany.Name != "" &&
                < Container id="rdTitle" fluid className="horizontalAlignment fullWidth">
                    {
                        location == "Pautas" && <Image className="logo-print print-only" src={Logo} alt="EDP" rounded />
                    }
                    <Container fluid className="verticalAlignment">
                        <h2>{location} | {currentCompany?.Name}</h2>
                        <span className="print-only" >Impresso em: <Moment format="DD/MM/YYYY HH:mm:ss" /></span>
                    </Container>
                </Container>
            }
            <Container id="rdContentWrapper" fluid>
                {window.innerWidth > 1280 && <Container id="rdSideMenu-wrapper" className="remove-print" fluid ><SideMenu /></Container>}
                <Container id="rdContent-wrapper" fluid><Content pageContentRef={pageContentRef} children={children} /></Container>
            </Container>
            <Footer />
        </Container>
    );
};

export default PageLayout;